import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import "bootstrap/dist/css/bootstrap.min.css";
import { Amplify } from "aws-amplify";
import { COGNITO_CONFIG } from "./AppConfig";
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: COGNITO_CONFIG.REGION,
    userPoolId: COGNITO_CONFIG.USER_POOL_ID,
    userPoolWebClientId: COGNITO_CONFIG.APP_CLIENT_ID,
    oauth: {
      domain: COGNITO_CONFIG.DOMAIN,
      scope: COGNITO_CONFIG.SCOPE,
      redirectSignIn: COGNITO_CONFIG.REDIRECT_SIGN_IN,
      redirectSignOut: COGNITO_CONFIG.REDIRECT_SIGN_OUT,
      responseType: COGNITO_CONFIG.RESPONSE_TYPE,
      urlOpener: window.location.assign.bind(window.location),
    },
    cookieStorage: {
      domain: "bloomnloomspeechtherapy.com", //use "localhost" when running locally
      secure: false,
      sameSite: "lax",
      path: "/",
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
